var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.791 0.75C11.0672 0.75 11.3215 0.902201 11.4521 1.14551L12.4482 3H16.5C16.9142 3 17.25 3.33579 17.25 3.75C17.25 4.16421 16.9142 4.5 16.5 4.5H15.375V16.5C15.375 16.9142 15.0392 17.25 14.625 17.25H3.375C2.96079 17.25 2.625 16.9142 2.625 16.5V4.5H1.5C1.08579 4.5 0.75 4.16421 0.75 3.75C0.75 3.33579 1.08579 3 1.5 3H5.55664L6.57617 1.13965C6.70784 0.899513 6.95953 0.75 7.2334 0.75H10.791ZM4.125 15.75H13.875V4.5H4.125V15.75ZM7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5V12.375C8.25 12.7892 7.91421 13.125 7.5 13.125C7.08579 13.125 6.75 12.7892 6.75 12.375V7.5C6.75 7.08579 7.08579 6.75 7.5 6.75ZM10.5 6.75C10.9142 6.75 11.25 7.08579 11.25 7.5V12.375C11.25 12.7892 10.9142 13.125 10.5 13.125C10.0858 13.125 9.75 12.7892 9.75 12.375V7.5C9.75 7.08579 10.0858 6.75 10.5 6.75ZM7.2666 3H10.7461L10.3428 2.25H7.67773L7.2666 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.165e2f882dec0c2cd8ec0ea2f0b7a296.svg";
export { ForwardRef as ReactComponent };